var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
import React from 'react';
import styles from 'core-components/src/components/card/card.scss';
import cn from 'classnames';
const Card = (_a) => {
    var { distance, fluid, className, children } = _a, props = __rest(_a, ["distance", "fluid", "className", "children"]);
    const css = cn({
        [styles.card]: true,
        [styles[`level-${distance}`]]: true,
        [styles.fluid]: fluid,
        [className]: className
    });
    return (React.createElement("div", Object.assign({}, props, { className: css }), children));
};
Card.defaultProps = {
    distance: 1,
    fluid: false
};
export { Card };
